import { api } from '.';
import moment from "moment/moment";

export interface Communication {
  id?: string;
  recipients: string[];
  headline?: string;
  senderText: string;
  message: string;
  isTemplate?: boolean;
  channel: number;
  overridePreferences: boolean;
}

interface Recipient {
  messageId: string;
  recipientId: string;
  email: string;
  phoneNumber: string;
  recipientName: string;
}

export interface MassMessageHistory {
  id: string;
  headline?: string;
  senderText?: string;
  message: string;
  created: string;
  channel: number;
  updated: string;
  isTemplate?: boolean;
  overridePreferences: boolean;
  deliveredRecipients: Recipient[];
  undeliveredRecipients: Recipient[];
}

export interface CommunicationErrorModel {
  Recipients?: string[];
  Headline?: string[];
  SenderText?: string[];
  Message?: string[];
  Channel?: string[];
  OverridePreferences?: string[];
  ServerError?: string[];
}

const communicationApi = api.injectEndpoints({
  endpoints: builder => ({
    massMessageHistory: builder.query<MassMessageHistory[], void>({
      query: () => ({
        url: 'Communication/Mass/History',
        method: 'GET',
      }),
      providesTags: ['CommunicationHistory'],
      transformResponse: (response: { data: MassMessageHistory[] }) => response.data,
    }),
    sendMassMessage: builder.mutation<string, Communication>({
      query: communication => ({
        url: 'Communication/Mass/Send',
        method: 'POST',
        body: communication,
      }),
      invalidatesTags: ['CommunicationHistory'],
      transformResponse: (response: { data: string }) => response.data,
    }),

    massMessageTemplates: builder.query<MassMessageHistory[], void>({
      query: () => ({
        url: 'Communication/Mass/Templates',
        method: 'GET',
      }),
      providesTags: ['CommunicationHistory'],
      transformResponse: (response: { data: MassMessageHistory[] }) => response.data,
    }),
    saveTemplate: builder.mutation<Communication, Communication>({
      query: communication => ({
        url: 'Communication/Mass/Create/Template',
        method: 'POST',
        body: communication,
      }),
      invalidatesTags: ['CommunicationHistory'],
      transformResponse: (response: { data: Communication }) => response.data,
    }),
    updateTemplate: builder.mutation<string, Communication>({
      query: communication => ({
        url: 'Communication/Mass/Update/Template',
        method: 'POST',
        body: communication,
      }),
      invalidatesTags: ['CommunicationHistory'],
      transformResponse: (response: { data: string }) => response.data,
    }),
    deleteTemplate: builder.mutation<string, string>({
      query: templateId => ({
        url: `Communication/Mass/Delete/Template/${templateId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CommunicationHistory'],
      transformResponse: (response: { data: string }) => response.data,
    }),
  }),
});

export const {
  useMassMessageHistoryQuery,
  useSendMassMessageMutation,
  useMassMessageTemplatesQuery,
  useSaveTemplateMutation,
  useUpdateTemplateMutation,
  useDeleteTemplateMutation,
} = communicationApi;
